import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UpdateCartItem } from '../../redux/Slices/CartSlice'
import notify from '../UseNotification'

const UseUpdateCartItem = (item) => {

    const dispatch = useDispatch()
    const [ImageCover, setImageCover] = useState("")
    const [CategoryName, setCategoryName] = useState("")
    const [ProductName, setProductName] = useState("")
    const [RatingAverage, setRatingAverage] = useState("")
    const [BrandName, setBrandName] = useState("")
    const [loading, setLoading] = useState(true)
    const [productId, setProductId] = useState("")
    const [countValue, setcountValue] = useState("")
    const { updateCartData } = useSelector(state => state.CartReducer)

    // to get image cover
    useEffect(() => {
        if (item) {
            if (item.product) {
                setImageCover(item.product.imageCover)
                setCategoryName(item.product.category?.name)
                setProductName(item.product.title)
                setRatingAverage(item.product.ratingsAverage)
                setBrandName(item.product.brand?.name)
                setcountValue(item.count)
                setProductId(item._id)
            }
            else if (item.product === null) {
                setImageCover("")
                setCategoryName("")
                setProductName("")
                setRatingAverage("")
                setBrandName("")
                setcountValue("")
                setProductId("")
            }
        }
    }, [item])


    //handle change count value
    const handleChangeCountValue = async (e) => {
        setcountValue(e.target.value)
    }


    // handle update data 
    const handleUpdateCartData = async () => {
        setLoading(true)
        await dispatch(UpdateCartItem({
            id: productId,
            data: {
                count: countValue
            }
        }))
        setLoading(false)
    }

    // handle update data baseb on the count value
    useEffect(() => {
        handleUpdateCartData()
    }, [countValue])

    // handle response 
    useEffect(() => {
        if (loading === false) {
            if (updateCartData.status === 200) {
                notify("total price changed", "success")
                window.location.reload(false)
            } 
        }
    }, [loading])

    return [handleChangeCountValue, countValue, ImageCover, CategoryName, ProductName, RatingAverage, BrandName]
}

export default UseUpdateCartItem
